<template>
  <el-dialog :close-on-click-modal="false"  
    title="备注"
    :visible.sync="visible"
    width="400px"
    class="remarkDialog"
    :before-close="handleClose"
    
  >
    <el-form :model="form" ref="form" label-width="80px">
      <el-form-item label="内容：">
        <el-input
          v-model="form.content"
          class="input"
          size="small"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="颜色："> 
        <div class="item">
          <div
            v-for="(value, index) in dictData['color']"
            :key="index"
            :class="['color', value.value === form.color ? 'active' : '']"
            @click="pickColor(value.value)"
          >
            <div class="color-inner" :style="'background: ' +  value.value"></div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small">
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RemarkDialog",
  data() {
    return {
      form: {
        content: "",
        color: "",
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  methods: {
    pickColor(data) {
      this.form.color = data;
    },
    sure() {
      console.log("remark", this.form);
      this.$emit("onClose", this.form);
    },
    handleClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style scoped>
.remarkDialog {
  font-size: 12px;
}

.item {
  display: flex;
  flex-wrap: wrap;
}

.color {
  padding: 1px;
  margin: 3px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 4px;
  border: 1px solid #eee;
}

.color.active {
  border: 1px solid #333;
}

.color-inner {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}
</style>
